import { Record, List } from 'immutable';

import TypeItem, { UOM_KEY_EACH } from './TypeItem';

const defaultValues = {
  id: null,
  brandId: 0,
  abbreviation: '',
  uomdesc: '',
  archived: false,
  createdBy: null,
  created: null,
  updatedBy: null,
  updated: null,
};

export default class CustomUom extends Record(defaultValues, CustomUom) {
  constructor(values) {
    super({
      ...values,
    });
  }

  static filterOutCount(typeItems) {
    return typeItems.filter(type => {
      return TypeItem.isCount(type.get('abbreviation')) ? undefined : type;
    });
  }

  static filterOutImperialWeights(typeItems) {
    return typeItems.filter(type => {
      return TypeItem.isImperialWeight(type.get('abbreviation')) ? undefined : type;
    });
  }

  static filterOutImperialVolumes(typeItems) {
    return typeItems.filter(type => {
      return TypeItem.isImperialVolume(type.get('abbreviation')) ? undefined : type;
    });
  }

  static filterCustomUomByName(customUoms, keywords) {
    let keywordsUpper = keywords.toUpperCase();
    return customUoms.filter((uom) => {
      return uom.get('abbreviation') && uom.get('abbreviation').toUpperCase().includes(keywordsUpper)
      || uom.get('uomdesc') && uom.get('uomdesc').toUpperCase().includes(keywordsUpper);
    });
  }

  static sortCustomUomByName(customUoms) {
    return customUoms.sort((itemOne, itemTwo) => {
      return itemOne.abbreviation.localeCompare(itemTwo.abbreviation);
    });
  }

  static filterCustomUomItemByName(customUoms, key, fromPICSource) {
    return customUoms.filter((uom) => {
      return uom.get('abbreviation').toUpperCase() === key.toUpperCase()
      || (fromPICSource ? uom.get('uomdesc').toUpperCase() === key.toUpperCase() :
      uom.get('typeItemName').toUpperCase() === key.toUpperCase());
    })
  }

  static filterOutMetricWeights(typeItems) {
    return typeItems.filter(type => {
      return TypeItem.isMetricWeight(type.get('abbreviation')) ? undefined : type;
    });
  }

  static filterOutByMetricVolumes(typeItems) {
    return typeItems.filter(type => {
      return TypeItem.isMetricVolume(type.get('abbreviation')) ? undefined : type;
    });
  }

  static findCommonCustomUomById(customUoms, id) {
    return customUoms.find(uom => {
      return uom.get('id') === id;
    });
  }

  /**
   * return the UOMs in opposite data model
   * volume metrics => weight metrics
   * weight metrics => volume metrics
   * ea/ct/unknown => all
   * @param {*} commonUoms
   * @param {*} customUoms
   * @param {*} textKey
   */
  static getCustomUnitsByTextKey(commonUoms, customUoms, textKey) {
    let filteredUoms = commonUoms;

    if (textKey !== UOM_KEY_EACH) {
      // Count values only
      if (TypeItem.isCount(textKey)) {
        filteredUoms = CustomUom.filterOutCount(filteredUoms);
      }
      // Imperial plus count if imperial
      if (TypeItem.isImperialWeight(textKey)) {
        filteredUoms = CustomUom.filterOutImperialWeights(filteredUoms);
        filteredUoms = CustomUom.filterOutCount(filteredUoms);
      }
      // Imperial volumes
      if (TypeItem.isImperialVolume(textKey)) {
        filteredUoms = CustomUom.filterOutImperialVolumes(filteredUoms);
        filteredUoms = CustomUom.filterOutCount(filteredUoms);
      }
      // Metric plus count if metric
      if (TypeItem.isMetricWeight(textKey)) {
        filteredUoms = CustomUom.filterOutMetricWeights(filteredUoms);
        filteredUoms = CustomUom.filterOutCount(filteredUoms);
      }
      if (TypeItem.isMetricVolume(textKey)) {
        filteredUoms = CustomUom.filterOutByMetricVolumes(filteredUoms);
        filteredUoms = CustomUom.filterOutCount(filteredUoms);
      }
    }

    return customUoms.concat(filteredUoms);
  }
}

export const CustomUoms = data => {
  let customUomList = new List();
  if (data) {
    data.forEach(value => {
      customUomList = customUomList.push(new CustomUom(value));
    });
  }
  return customUomList;
};
